// import { useEffect, useState } from "react"
// import { getCcAvenueEncryptedString, getPaymentProviders, paymentFailOrderCancel } from "../services/services"
// import * as language from '../constants/languages'
// import { useNavigate, useParams,useLocation } from "react-router-dom"
// import { Spinner } from 'react-bootstrap';

// export function PaymentsPage() {
//     const { order_id, totalAmount, token, branch_id } = useParams()
//     console.log(order_id, token)
//     const navigate = useNavigate()
//      const location = useLocation();

//      const orderSummaryData = location.state?.orderSummaryData;

// console.log(orderSummaryData,"orderData>>>>>>");

//     async function generateHash(dataString, algorithm = 'SHA-256') {
//         // Convert the data string to an ArrayBuffer
//         const encoder = new TextEncoder();
//         const dataBuffer = encoder.encode(dataString);

//         // Generate the hash
//         const hashBuffer = await window.crypto.subtle.digest(algorithm, dataBuffer);

//         // Convert the hash to a hex string
//         const hashArray = Array.from(new Uint8Array(hashBuffer));
//         const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');

//         return hashHex;
//     }

//     const handleResponse = (res) => {
//         console.log(res, "callback")
//         if (typeof res !== "undefined" &&
//             typeof res.paymentMethod !== "undefined" &&
//             typeof res.paymentMethod.paymentTransaction !== "undefined" &&
//             typeof res.paymentMethod.paymentTransaction.statusCode !== "undefined") {
//             if (res.paymentMethod.paymentTransaction.statusCode === "0300") {
//                 // success block
//                 navigate(`/PaymentSuccess/${order_id}`)
//             } else if (res.paymentMethod.paymentTransaction.statusCode === "0398") {
//                 // initiated block
//             } else {
//                 // error block
//                 navigate(`/PaymentFail/${order_id}`)
//             }
//         }
//     };
//     async function initPayment() {
//         // debugger

//         const consumerData = {
//             deviceId: "WEBSH2", //possible values "WEBSH1" or "WEBSH2"
//             token: "",
//             returnUrl: "https://api.xeniacatalogue.info/api/WorldLine/Callback", //merchant response page URL
//             responseHandler: handleResponse,
//             paymentMode: "all",
//             merchantLogoUrl: "https://www.paynimo.com/CompanyDocs/company-logo-vertical.png", //provided merchant logo will be displayed
//             merchantId: "L995912",
//             currency: "INR",
//             // consumerId: "c1234",
//             txnId: order_id, //Unique merchant transaction ID
//             items: [{
//                 "itemId": "first",
//                 "amount": totalAmount,
//                 "comAmt": "0"
//             }],
//             customStyle: {
//                 PRIMARY_COLOR_CODE: "#45beaa", //merchant primary color code
//                 SECONDARY_COLOR_CODE: "#FFFFFF", //provide merchant's suitable color code
//                 BUTTON_COLOR_CODE_1: "#2d8c8c", //merchant's button background color code
//                 BUTTON_COLOR_CODE_2: "#FFFFFF" //provide merchant's suitable color code for button text
//             },
//             accountNo: "", // Add actual value
//             consumerMobileNo: "", // Add actual value
//             consumerEmailId: "", // Add actual value
//             debitStartDate: "", // Add actual value
//             debitEndDate: "", // Add actual value
//             maxAmount: "", // Add actual value
//             amountType: "", // Add actual value
//             frequency: "", // Add actual value
//             cardNumber: "", // Add actual value
//             expMonth: "", // Add actual value
//             expYear: "", // Add actual value
//             cvvCode: "" // Add actual value
//         };

//         const salt = "2826959584TDEWOB"; // Replace with the actual salt value provided by Worldline
//         const dataString = [
//             consumerData.merchantId,
//             consumerData.txnId,
//             totalAmount,
//             consumerData.accountNo,
//             consumerData.consumerId,
//             consumerData.consumerMobileNo,
//             consumerData.consumerEmailId,
//             consumerData.debitStartDate,
//             consumerData.debitEndDate,
//             consumerData.maxAmount,
//             consumerData.amountType,
//             consumerData.frequency,
//             consumerData.cardNumber,
//             consumerData.expMonth,
//             consumerData.expYear,
//             consumerData.cvvCode,
//             salt
//         ].join('|');

//         const hashValue = await generateHash(dataString, 'SHA-512');
//         consumerData.token = hashValue
//         console.log('Generated Hash:', hashValue);


//         const reqJson = {
//             features: {
//                 enableAbortResponse: true,
//                 enableExpressPay: true,
//                 enableInstrumentDeRegistration: true,
//                 enableMerTxnDetails: true,
//             },
//             consumerData: consumerData
//         };

//         window.$.pnCheckout(reqJson);
//         if (reqJson.features.enableNewWindowFlow) {
//             window.pnCheckoutShared.openNewWindow();
//         }
//     }


//     async function cancelOrderOnError() {
//         try {
//             await paymentFailOrderCancel(language.companyidValue, branch_id, order_id, token)
//         } catch (error) {
//             console.log(error, 'err')
//         }
//         navigate(`/PaymentFail/${order_id}`)
//     }


//     useEffect(() => {
//         initPayment()
//     }, [])
//     return (
//         <>
//             <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//                 <Spinner animation="border" role="status" />
//             </div>
//         </>

//     )
// }



import { useEffect, useRef, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import * as language from "../constants/languages";
import {
    createRazorPayOrder,
    placeOrder,
    checkOrderStatus,
    fetchPaymentsById,
} from "../services/services";

export function PaymentsPage() {
    const { order_id, totalAmount, token, branch_id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    console.log("token>>>", token);


    const orderSummaryData =
        location.state?.orderSummaryData ||
        JSON.parse(sessionStorage.getItem("order_details"));

    const [razorPayOrderId, setRazorPayOrderId] = useState(null);
    const [isPending, setIsPending] = useState(false);
     const [orderReferenceNumber, setOrderReferenceNumber] = useState(null)

    const paymentRefetchInterval = useRef(null);
    const orderStatusInterval = useRef(null);

    // =========================
    // SUCCESS CALLBACK
    // =========================
    const paymentSuccess = async (response) => {
        const orderPayload = {
            OrderPaymentId: response.razorpay_payment_id,
            PaymentRef: response.razorpay_order_id,
            PaymentMessage: null,
            providers: [],
            OrderId: orderSummaryData.orderId,
            PaymentAmount: orderSummaryData.totalAmount,
            Status: orderSummaryData.status,
            PaymentProviderType: "RAZORPAY",
            PaymentProviderName: "Razorpay",
            PaymentMethod: null,
            PaymentProviderId: null,
            PaymentDate: new Date(),
            OrderChanel: "Web",
        };

        await orderPlacement(orderPayload, 3, 2000);
    };

    // =========================
    // FAILURE CALLBACK
    // =========================
    const paymentFail = () => {
        navigate(`/PaymentFail/${order_id}`);
    };

     // =========================
    // CHECK ORDER STATUS (to get reference number)
    // =========================
    async function getOrderStatusForReference() {
        try {
            const response = await checkOrderStatus(
                language.companyidValue,
                orderSummaryData.orderId
            );
            console.log("order status response>>>>>", response);

            if (response?.message) {
                setOrderReferenceNumber(response.message);
                sessionStorage.setItem("order_reference_number", response.message);
                return response.message;
            }
            return null;
        } catch (error) {
            console.error(error);
            return null;
        }
    }

    // =========================
    // PLACE ORDER WITH RETRY
    // =========================
    async function orderPlacement(order, retries, delay) {
        try {
            const response = await placeOrder(
                language.companyidValue,
                order,
                branch_id,
                token
            );
            console.log(response, "response from payment page");


            if (response.status === "success") {
                sessionStorage.removeItem("cartItems");
                sessionStorage.setItem(
                    "placed_order",
                    JSON.stringify(response.data)
                );
                // Get the reference number after successful order placement
                const referenceNumber = await getOrderStatusForReference();
                // navigate(`/PaymentSuccess/${order_id}`);
                navigate(`/PaymentSuccess/${order_id}`, {
                    state: { token: token },
                    orderReferenceNumber: referenceNumber,
                    orderPlacedData: response?.data,
                });
            } else {
                throw new Error("Order placement failed");
            }
        } catch (error) {
            if (retries > 0) {
                setTimeout(() => {
                    orderPlacement(order, retries - 1, delay * 2);
                }, delay);
            } else {
                setIsPending(true);
            }
        }
    }

    // =========================
    // CHECK ORDER STATUS
    // =========================
    async function getOrderStatus() {
        try {
            const response = await checkOrderStatus(
                language.companyidValue,
                orderSummaryData.orderId
            );
            console.log("order status response>>>>>", response);

            if (
                response.status === "success" &&
                response.data[0].status === "ORDERED"
            ) {
                clearInterval(orderStatusInterval.current);
                navigate(`/PaymentSuccess/${order_id}`);
            }
        } catch (error) {
            console.error(error);
        }
    }

    // =========================
    // PAYMENT REFETCH
    // =========================
    async function refetchPayment(orderId) {
        try {
            const response = await fetchPaymentsById(orderId);

            if (response.items?.length > 0) {
                const success = response.items.find(
                    (it) => it.status === "captured"
                );

                const pending = response.items.find(
                    (it) => it.status === "authorized"
                );

                if (success) {
                    clearInterval(paymentRefetchInterval.current);

                    paymentSuccess({
                        razorpay_payment_id: success.id,
                        razorpay_order_id: success.order_id,
                    });
                } else if (pending) {
                    setIsPending(true);
                }
            }
        } catch (error) {
            console.error(error);
        }
    }

    // =========================
    // INIT RAZORPAY
    // =========================
    async function initiateRazorPay() {
        try {
            const createOrderResponse = await createRazorPayOrder(
                orderSummaryData.orderId,
                orderSummaryData.totalAmount * 100,
                token
            );

            console.log("createOrderResponse>>>>>", createOrderResponse);


            if (
                createOrderResponse.status === "success" &&
                createOrderResponse.data.amount ===
                orderSummaryData.totalAmount * 100
            ) {
                setRazorPayOrderId(createOrderResponse.data.orderId);

                const options = {
                    key: 'rzp_live_9CElqbN3Q2ux5T',
                    amount: createOrderResponse.data.amount,
                    currency: "INR",
                    name: "Marian College Canteen",
                    description: "",
                    order_id: createOrderResponse.data.orderId,

                    handler: paymentSuccess,

                    modal: {
                        ondismiss: paymentFail,
                    },

                    prefill: {
                        contact: "",
                        name: "",
                    },

                    theme: {
                        color: "#45beaa",
                    },
                };

                const razorpay = new window.Razorpay(options);
                razorpay.open();
            } else {
                navigate(-1);
            }
        } catch (error) {
            console.error(error);
            navigate(-1);
        }
    }

    // =========================
    // INITIAL LOAD
    // =========================
    useEffect(() => {
        initiateRazorPay();
    }, [orderSummaryData.orderId]);

    // =========================
    // PAYMENT POLLING
    // =========================
    useEffect(() => {
        if (razorPayOrderId) {
            paymentRefetchInterval.current = setInterval(() => {
                refetchPayment(razorPayOrderId);
            }, 5000);
        }

        return () => clearInterval(paymentRefetchInterval.current);
    }, [razorPayOrderId]);

    // =========================
    // ORDER STATUS POLLING
    // =========================
    useEffect(() => {
        if (isPending) {
            orderStatusInterval.current = setInterval(() => {
                getOrderStatus();
            }, 5000);
        }

        return () => clearInterval(orderStatusInterval.current);
    }, [isPending]);

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
            }}
        >
            <Spinner animation="border" />
        </div>
    );
}